/**
 * Copyright 2025 John Huikku Alienrobot LLC
 * www.ALIENROBOT.com
 */

import { useState } from 'react'

interface UseJudgeSettingsReturn {
  judgeAutoSend: boolean
  judgeThreshold: number
  judgeNotes: string
  isEditingThreshold: boolean
  approvalSent: boolean
  setJudgeAutoSend: (autoSend: boolean) => void
  setJudgeThreshold: (threshold: number) => void
  setJudgeNotes: (notes: string) => void
  setIsEditingThreshold: (editing: boolean) => void
  setApprovalSent: (sent: boolean) => void
}

export function useJudgeSettings(): UseJudgeSettingsReturn {
  const [judgeAutoSend, setJudgeAutoSend] = useState(true) // Auto-send on by default
  const [judgeThreshold, setJudgeThreshold] = useState(0.90)
  const [judgeNotes, setJudgeNotes] = useState('')
  const [isEditingThreshold, setIsEditingThreshold] = useState(false)
  const [approvalSent, setApprovalSent] = useState(false)

  return {
    judgeAutoSend,
    judgeThreshold,
    judgeNotes,
    isEditingThreshold,
    approvalSent,
    setJudgeAutoSend,
    setJudgeThreshold,
    setJudgeNotes,
    setIsEditingThreshold,
    setApprovalSent,
  }
}

